import { Code, ConnectError } from "@connectrpc/connect";

/** Returns the Connect code of any error a call threw. */
export function errorCode(err: unknown): Code {
  return ConnectError.from(err).code;
}

const transient = new Set([Code.Unknown, Code.Unavailable, Code.DeadlineExceeded, Code.Aborted, Code.Internal]);

/** Retries a query once, and only for errors that a second try might fix. */
export function retryTransient(failureCount: number, err: unknown): boolean {
  return failureCount < 1 && transient.has(errorCode(err));
}
